module.exports = __webpack_public_path__ + "img/banner1.0ae8a2e1.png";